import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import '@fortawesome/fontawesome-free/css/all.min.css';

// serviceWorkerRegistration.register();
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";

import App from './App';
import store from "./redux/store";
import './index.css';
import AnalyticsTracker from './components/AnalyticsTracker';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <Provider store={store}>
            <AnalyticsTracker />
            <App />
        </Provider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// Global handler to ignore third-party browser extension errors and auto-recover ChunkLoadErrors
window.addEventListener('error', (event) => {
  if (
    event?.filename?.includes('chrome-extension:') ||
    event?.message?.includes('M_ID') ||
    event?.error?.stack?.includes('chrome-extension:')
  ) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return;
  }

  const isChunkError =
    event?.message?.includes('Loading chunk') ||
    event?.message?.includes('ChunkLoadError') ||
    event?.message?.includes('Failed to fetch dynamically imported module');

  if (isChunkError) {
    const lastReload = sessionStorage.getItem('chunk_reload_timestamp');
    const now = Date.now();
    // Prevent infinite reload loops (only reload if at least 10s passed)
    if (!lastReload || now - parseInt(lastReload, 10) > 10000) {
      sessionStorage.setItem('chunk_reload_timestamp', now.toString());
      window.location.reload();
    }
  }
}, true);

window.addEventListener('unhandledrejection', (event) => {
  if (
    event?.reason?.stack?.includes('chrome-extension:') ||
    event?.reason?.message?.includes('M_ID')
  ) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
}, true);

// Purge legacy caches left behind from older versions
if ('caches' in window) {
  caches.keys().then((cacheNames) => {
    cacheNames.forEach((name) => {
      if (name !== 'cardplot-cache-v3') {
        caches.delete(name);
      }
    });
  });
}

// Automatically activate new service worker and refresh seamlessly
if ('serviceWorker' in navigator) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true;
      window.location.reload();
    }
  });
}

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    const waitingServiceWorker = registration.waiting;
    if (waitingServiceWorker) {
      waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
    }
  },
});

